import styles from '../StepLayout.module.css';
import { StepLayout } from '../StepLayout';
import { ru } from '@/i18n/ru';

export function Step4Bonuses() {
  return (
    <StepLayout title={ru.onboarding.step4.title}>
      <ul className={styles.list}>
        <li>{ru.onboarding.step4.uniqueness}</li>
        <li>{ru.onboarding.step4.speed}</li>
      </ul>
    </StepLayout>
  );
}
